<template>
	<section class="page-login">
		<PageHeader title="Login" />
		<LoginForm />
	</section>
</template>

<script>
import LoginForm from './LoginForm';
import PageHeader from '../shared/PageHeader';

export default {
	name: 'Login',
	components: {
		LoginForm,
		PageHeader,
	},
};
</script>
